import { useCallback, useContext } from 'react';
import { WorkflowEntityContext } from './workflowEntityContext';

export function useUpdateField() {
  const { updateField } = useContext(WorkflowEntityContext);
  return useCallback(updateField, [updateField]);
}

export function useField(fieldName: string) {
  const { workflowEntity } = useContext(WorkflowEntityContext);
  return workflowEntity?.fields?.[fieldName] ?? null;
}

export function useLoadingAndError() {
  const { loading, error } = useContext(WorkflowEntityContext);
  return { loading, error };
}
